import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { store } from './app/redux/store';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import './index.css';
import 'react-toastify/dist/ReactToastify.css';
// import { QueryClientProvider, QueryClient } from 'react-query';

const root = ReactDOM.createRoot(document.getElementById('root'));
// const queryClient = new QueryClient();

root.render(
    <React.StrictMode>
        <Provider store={store}>
            {/* <QueryClientProvider client={queryClient}> */}
            <ToastContainer position="bottom-right" rtl={true} pauseOnHover closeOnClick />
            <App />
            {/* </QueryClientProvider> */}
        </Provider>
    </React.StrictMode>,
);
